import {z} from '@hono/zod-openapi';

/**
 * The highlighted features Alpha knows for the request vehicle. The key is absent when the
 * vehicle carries no make, model family and year.
 */
export const priceReportFeaturesResponseSchema = z
  .object({features: z.array(z.string()).optional()})
  .openapi('PriceReportFeaturesResponse');
